import React from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import IndustrialForm from '../Components/IndustrialForm'

const Contact = () => {
  return (
    <div>
      <Navbar />
      <IndustrialForm />
      <Footer />
    </div>
  )
}

export default Contact